import React, { lazy, useContext } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Route,
  Redirect,
} from "react-router-dom";
import AccessibleNavigationAnnouncer from "./components/AccessibleNavigationAnnouncer";
import ProtectedRoute from "./components/ProtectedRoute";
import Loader from "./components/Loader"; // Ensure this component is created as discussed earlier
import { Toaster } from "react-hot-toast"; // Import the Toaster component
import { UserContext } from "./context/UserContext";
import VersionChecker from "./versionChecker";

// Lazy load the components
const Layout = lazy(() => import("./containers/Layout"));
const Login = lazy(() => import("./pages/Login"));
const CreateAccount = lazy(() => import("./pages/CreateAccount"));
const ForgotPassword = lazy(() => import("./pages/ForgotPassword"));
const NotFound = lazy(() => import("./pages/404"));

function App() {
  const { user, loading } = useContext(UserContext);

  // Show loader while user data is being fetched
  if (loading) {
    return <Loader />;
  }

  return (
    <Router>
      <AccessibleNavigationAnnouncer />
      <VersionChecker />
      <Toaster position="top-right" />
      <Switch>
        {/* Public Routes */}
        <Route exact path="/login" component={Login} />
        <Route path="/create-account" component={CreateAccount} />
        <Route path="/forgot-password" component={ForgotPassword} />

        {/* Protected Routes */}
        <ProtectedRoute path="/app" component={Layout} />

        {/* Redirect to login if no other routes match */}
        {user ? (
          <Redirect exact from="/" to="/app" />
        ) : (
          <Redirect exact from="/" to="/login" />
        )}

        {/* 404 Not Found Route */}
        <Route path="*" component={NotFound} />
      </Switch>

      <Toaster
        position="top-right"
        toastOptions={{
          success: {
            duration: 3000,
            style: {
              background: "#34D399",
              color: "white",
            },
          },
          error: {
            duration: 4000,
            style: {
              background: "#EF4444",
              color: "white",
            },
          },
        }}
      />
    </Router>
  );
}

export default App;
